import React, { useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { Container, Row, Col, Card, Form, Button, Table, Badge, Alert, ProgressBar, Tabs, Tab, Modal } from "react-bootstrap";
import { FaPlus, FaEdit, FaTrash, FaArrowLeft, FaSearch, FaCalendarAlt, FaDownload, FaUpload, FaCheck, FaTimes, FaCheckCircle, FaExclamationTriangle, FaClipboardList, FaUtensils, FaInfoCircle, FaSave } from "react-icons/fa";
import axios from "axios";
import ModalConfirmacion from "../../../components/modals/ModalConfirmacion";

const API_URL = process.env.REACT_APP_PYTHON_API_URL || "http://localhost:8003";

const DIAS_SEMANA = [
  { id: 1, nombre: "Lunes" },
  { id: 2, nombre: "Martes" },
  { id: 3, nombre: "Miércoles" },
  { id: 4, nombre: "Jueves" },
  { id: 5, nombre: "Viernes" },
  { id: 6, nombre: "Sábado" },
  { id: 7, nombre: "Domingo" },
];

const MantenimientoMenusCiclicos = () => {
  const navigate = useNavigate();
  const token = localStorage.getItem("token");

  // Estados principales
  const [menus, setMenus] = useState([]);
  const [tiposServicio, setTiposServicio] = useState([]);
  const [tiposComponente, setTiposComponente] = useState([]);
  const [recetas, setRecetas] = useState([]);
  const [loading, setLoading] = useState(false);
  const [state, setState] = useState({
    menuSeleccionado: null,
    filtro: "",
  });

  // Tab principal
  const [activeMainTab, setActiveMainTab] = useState('individual'); // 'individual' o 'masiva'

  // Modal CRUD Cabecera
  const [showModalCabecera, setShowModalCabecera] = useState(false);
  const [modalMode, setModalMode] = useState('create'); // 'create' o 'edit'
  const [formDataCabecera, setFormDataCabecera] = useState({ codigo_interno: '', nombre: '', descripcion: '' });

  // Modal Grilla Semanal
  const [showModalGrilla, setShowModalGrilla] = useState(false);
  const [menuActual, setMenuActual] = useState(null);
  const [semanaOrdinal, setSemanaOrdinal] = useState(1);
  const [grillaData, setGrillaData] = useState({}); // {tipo_servicio_id: {dia_semana: {tipo_componente_id, receta_id, factor}}}

  // Modal de confirmación de eliminación
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [menuToDelete, setMenuToDelete] = useState(null);

  // Carga Masiva
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploadLoading, setUploadLoading] = useState(false);
  const [validationResult, setValidationResult] = useState(null);
  const [uploadStep, setUploadStep] = useState("select");
  const [showIndicacionesModal, setShowIndicacionesModal] = useState(false);

  // ========== Cargar datos ==========
  const fetchMenus = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${API_URL}/api/mantenimientos/planificacion-insumos/menus-ciclicos/`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setMenus(response.data);
    } catch (error) {
      console.error("Error al cargar menús:", error);
      toast.error("Error al cargar menús cíclicos");
    } finally {
      setLoading(false);
    }
  };

  const fetchTiposServicio = async () => {
    try {
      const response = await axios.get(
        `${API_URL}/api/mantenimientos/tipos-servicios-alimentacion/`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setTiposServicio(response.data);
    } catch (error) {
      console.error("Error al cargar tipos de servicio:", error);
      toast.error("Error al cargar tipos de servicio de alimentación");
    }
  };

  const fetchTiposComponente = async () => {
    try {
      const response = await axios.get(
        `${API_URL}/api/mantenimientos/planificacion-insumos/tipos-componente-menu/`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setTiposComponente(response.data);
    } catch (error) {
      console.error("Error al cargar tipos de componente:", error);
      toast.error("Error al cargar tipos de componente de menú");
    }
  };

  const fetchRecetas = async () => {
    try {
      const response = await axios.get(
        `${API_URL}/api/mantenimientos/planificacion-insumos/recetas/`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setRecetas(response.data);
    } catch (error) {
      console.error("Error al cargar recetas:", error);
      toast.error("Error al cargar recetas");
    }
  };

  useEffect(() => {
    fetchMenus();
    fetchTiposServicio();
    fetchTiposComponente();
    fetchRecetas();
  }, []);

  // Filtrar menús
  const menusFiltrados = menus.filter((menu) =>
    menu.nombre.toLowerCase().includes(state.filtro.toLowerCase()) ||
    (menu.descripcion && menu.descripcion.toLowerCase().includes(state.filtro.toLowerCase()))
  );

  // ========== CRUD Handlers Cabecera ==========
  const handleOpenCreateModal = () => {
    setModalMode('create');
    setFormDataCabecera({ codigo_interno: '', nombre: '', descripcion: '' });
    setShowModalCabecera(true);
  };

  const handleOpenEditModal = (menu) => {
    setModalMode('edit');
    setFormDataCabecera({
      id: menu.id,
      codigo_interno: menu.codigo_interno || '',
      nombre: menu.nombre,
      descripcion: menu.descripcion || ''
    });
    setShowModalCabecera(true);
  };

  const handleCloseModalCabecera = () => {
    setShowModalCabecera(false);
    setFormDataCabecera({ codigo_interno: '', nombre: '', descripcion: '' });
  };

  const handleSaveCabecera = async () => {
    if (!formDataCabecera.codigo_interno || formDataCabecera.codigo_interno.trim().length < 1) {
      toast.error("El código interno es obligatorio");
      return;
    }
    if (!formDataCabecera.nombre || formDataCabecera.nombre.trim().length < 1) {
      toast.error("El nombre es obligatorio");
      return;
    }

    setLoading(true);
    try {
      const payload = {
        codigo_interno: formDataCabecera.codigo_interno.trim(),
        nombre: formDataCabecera.nombre.trim(),
        descripcion: formDataCabecera.descripcion?.trim() || null
      };

      if (modalMode === 'create') {
        await axios.post(
          `${API_URL}/api/mantenimientos/planificacion-insumos/menus-ciclicos/`,
          payload,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        toast.success("Menú cíclico creado exitosamente");
      } else {
        await axios.put(
          `${API_URL}/api/mantenimientos/planificacion-insumos/menus-ciclicos/${formDataCabecera.id}`,
          payload,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        toast.success("Menú cíclico actualizado exitosamente");
      }
      fetchMenus();
      handleCloseModalCabecera();
    } catch (error) {
      const errorMsg = error.response?.data?.detail || "Error al guardar menú cíclico";
      toast.error(errorMsg);
    } finally {
      setLoading(false);
    }
  };

  // ========== Grilla Semanal ==========
  const handleOpenGrilla = async (menu, semana = 1) => {
    setMenuActual(menu);
    setSemanaOrdinal(semana);
    setGrillaData({});

    // Cargar detalles existentes para esta semana
    try {
      const response = await axios.get(
        `${API_URL}/api/mantenimientos/planificacion-insumos/menus-ciclicos/${menu.id}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      const menuCompleto = response.data;
      
      // Organizar datos por tipo_servicio y dia_semana
      const grilla = {};
      if (menuCompleto.detalles) {
        menuCompleto.detalles
          .filter(d => d.semana_ordinal === semana)
          .forEach(detalle => {
            if (!grilla[detalle.tipo_servicio_alimentacion_id]) {
              grilla[detalle.tipo_servicio_alimentacion_id] = {};
            }
            // Usar los códigos que vienen directamente del backend
            grilla[detalle.tipo_servicio_alimentacion_id][detalle.dia_semana] = {
              tipo_componente_menu_codigo: detalle.tipo_componente_menu_codigo || '',
              receta_codigo: detalle.receta_codigo || '',
              factor: detalle.factor
            };
          });
      }
      setGrillaData(grilla);
      setShowModalGrilla(true);
    } catch (error) {
      toast.error("Error al cargar detalles del menú");
    }
  };

  const handleCloseGrilla = () => {
    setShowModalGrilla(false);
    setMenuActual(null);
    setGrillaData({});
    setSemanaOrdinal(1);
  };

  const handleUpdateCelda = (tipoServicioId, diaSemana, campo, valor) => {
    const nuevaGrilla = { ...grillaData };
    if (!nuevaGrilla[tipoServicioId]) {
      nuevaGrilla[tipoServicioId] = {};
    }
    if (!nuevaGrilla[tipoServicioId][diaSemana]) {
      nuevaGrilla[tipoServicioId][diaSemana] = {
        tipo_componente_menu_codigo: '',
        receta_codigo: '',
        factor: '1.00'
      };
    }
    nuevaGrilla[tipoServicioId][diaSemana][campo] = valor;
    setGrillaData(nuevaGrilla);
  };

  const handleSaveGrilla = async () => {
    if (!menuActual) return;

    setLoading(true);
    try {
      // Eliminar detalles existentes de esta semana
      const menuCompleto = await axios.get(
        `${API_URL}/api/mantenimientos/planificacion-insumos/menus-ciclicos/${menuActual.id}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (menuCompleto.data.detalles) {
        const detallesSemana = menuCompleto.data.detalles.filter(d => d.semana_ordinal === semanaOrdinal);
        for (const detalle of detallesSemana) {
          await axios.delete(
            `${API_URL}/api/mantenimientos/planificacion-insumos/menus-ciclicos/detalles/${detalle.id}`,
            { headers: { Authorization: `Bearer ${token}` } }
          );
        }
      }

      // Crear nuevos detalles
      for (const tipoServicioId of Object.keys(grillaData)) {
        for (const diaSemana of Object.keys(grillaData[tipoServicioId])) {
          const celda = grillaData[tipoServicioId][diaSemana];
          if (celda.tipo_componente_menu_codigo && celda.receta_codigo && celda.factor) {
            await axios.post(
              `${API_URL}/api/mantenimientos/planificacion-insumos/menus-ciclicos/${menuActual.id}/detalles`,
              {
                semana_ordinal: semanaOrdinal,
                dia_semana: parseInt(diaSemana),
                tipo_servicio_alimentacion_id: parseInt(tipoServicioId),
                tipo_componente_menu_codigo: celda.tipo_componente_menu_codigo,
                receta_codigo: celda.receta_codigo,
                factor: parseFloat(celda.factor)
              },
              { headers: { Authorization: `Bearer ${token}` } }
            );
          }
        }
      }

      toast.success("Grilla semanal guardada exitosamente");
      handleCloseGrilla();
      fetchMenus();
    } catch (error) {
      const errorMsg = error.response?.data?.detail || "Error al guardar grilla semanal";
      toast.error(errorMsg);
    } finally {
      setLoading(false);
    }
  };

  // ========== Eliminar ==========
  const handleDeleteMenu = (menu) => {
    if (!menu) {
      toast.error("Por favor seleccione un menú para eliminar");
      return;
    }
    setMenuToDelete(menu);
    setShowConfirmModal(true);
  };

  const confirmDeleteMenu = async () => {
    if (!menuToDelete) return;

    setLoading(true);
    try {
      await axios.delete(
        `${API_URL}/api/mantenimientos/planificacion-insumos/menus-ciclicos/${menuToDelete.id}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      toast.success("Menú cíclico eliminado exitosamente");
      setState({ ...state, menuSeleccionado: null });
      fetchMenus();
      setShowConfirmModal(false);
      setMenuToDelete(null);
    } catch (error) {
      const errorMsg = error.response?.data?.detail || "Error al eliminar menú cíclico";
      toast.error(errorMsg);
    } finally {
      setLoading(false);
    }
  };

  // ========== Carga Masiva ==========
  const handleDownloadTemplate = async () => {
    try {
      const response = await axios.get(
        `${API_URL}/api/mantenimientos/planificacion-insumos/menus-ciclicos/plantilla/excel`,
        {
          headers: { Authorization: `Bearer ${token}` },
          responseType: "blob",
        }
      );

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "plantilla_menus_ciclicos.xlsx");
      document.body.appendChild(link);
      link.click();
      link.remove();

      toast.success("Plantilla descargada exitosamente");
    } catch (error) {
      toast.error("Error al descargar plantilla");
    }
  };

  const handleFileSelect = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (!file.name.endsWith(".xlsx") && !file.name.endsWith(".xls")) {
        toast.error("El archivo debe ser formato Excel (.xlsx o .xls)");
        return;
      }
      setSelectedFile(file);
      setUploadStep("select");
      setValidationResult(null);
    }
  };

  const handleValidateFile = async () => {
    if (!selectedFile) {
      toast.error("Por favor seleccione un archivo");
      return;
    }

    setUploadLoading(true);
    setUploadStep("validating");

    try {
      const formDataUpload = new FormData();
      formDataUpload.append("file", selectedFile);

      const response = await axios.post(
        `${API_URL}/api/mantenimientos/planificacion-insumos/menus-ciclicos/carga-masiva/validar`,
        formDataUpload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      setValidationResult(response.data);
      setUploadStep("validated");

      if (response.data.filas_validas > 0) {
        toast.success(
          `Validación exitosa: ${response.data.filas_validas} filas válidas de ${response.data.total_filas}`
        );
      } else {
        toast.warning("No hay filas válidas para cargar");
      }
    } catch (error) {
      const errorMsg = error.response?.data?.detail || "Error al validar archivo";
      toast.error(errorMsg);
      setUploadStep("select");
    } finally {
      setUploadLoading(false);
    }
  };

  const handleConfirmUpload = async () => {
    if (!selectedFile || !validationResult || validationResult.filas_validas === 0) {
      toast.error("No hay datos válidos para cargar");
      return;
    }

    setUploadLoading(true);
    setUploadStep("uploading");

    try {
      const formDataUpload = new FormData();
      formDataUpload.append("file", selectedFile);

      const response = await axios.post(
        `${API_URL}/api/mantenimientos/planificacion-insumos/menus-ciclicos/carga-masiva/confirmar`,
        formDataUpload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      toast.success(response.data.message);
      setUploadStep("success");
      fetchMenus();

      setTimeout(() => {
        handleResetUpload();
      }, 2000);
    } catch (error) {
      const errorMsg = error.response?.data?.detail || "Error en carga masiva";
      toast.error(errorMsg);
      setUploadStep("validated");
    } finally {
      setUploadLoading(false);
    }
  };

  const handleResetUpload = () => {
    setSelectedFile(null);
    setValidationResult(null);
    setUploadStep("select");
  };

  // Obtener valor de celda
  const getCeldaValue = (tipoServicioId, diaSemana, campo) => {
    return grillaData[tipoServicioId]?.[diaSemana]?.[campo] || '';
  };

  // Obtener estado de configuración de la celda
  const getCeldaStatus = (tipoServicioId, diaSemana) => {
    const celda = grillaData[tipoServicioId]?.[diaSemana];
    if (!celda) return 'empty';
    
    const tieneComponente = celda.tipo_componente_menu_codigo && celda.tipo_componente_menu_codigo.trim() !== '';
    const tieneReceta = celda.receta_codigo && celda.receta_codigo.trim() !== '';
    const tieneFactor = celda.factor && celda.factor.toString().trim() !== '';
    
    if (tieneComponente && tieneReceta && tieneFactor) return 'complete';
    if (tieneComponente || tieneReceta || tieneFactor) return 'partial';
    return 'empty';
  };

  // Obtener color de fondo según el estado
  const getCeldaBackgroundColor = (tipoServicioId, diaSemana) => {
    const status = getCeldaStatus(tipoServicioId, diaSemana);
    switch (status) {
      case 'complete': return '#d4edda'; // Verde claro
      case 'partial': return '#fff3cd';   // Amarillo claro
      case 'empty': return '#f8d7da';     // Rojo claro
      default: return '#fff';             // Blanco
    }
  };

  return (
    <>
      {/* Estilos similares a otros mantenimientos */}
      <style>
        {`
          .dh-maintenance-bg {
            background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
            min-height: 100vh;
          }
          .dh-main-header {
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            color: white;
            padding: 1.25rem 0;
            margin-bottom: 1.5rem;
            border-radius: 0 0 30px 30px;
            box-shadow: 0 10px 30px rgba(102, 126, 234, 0.2);
          }
          .dh-main-title {
            font-size: 1.4rem;
            font-weight: 700;
            margin: 0;
          }
          .dh-card {
            border: none;
            border-radius: 20px;
            box-shadow: 0 15px 35px rgba(0,0,0,0.1);
            background: white;
          }
          .dh-card-header {
            border-radius: 15px 15px 0 0;
            padding: 0.75rem 1rem;
            border: none;
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            color: white;
            font-weight: 700;
            font-size: 0.85rem;
          }
          .btn-dh-primary {
            background: linear-gradient(135deg, #11998e 0%, #38ef7d 100%);
            border: none;
            color: white;
            border-radius: 8px;
            padding: 6px 12px;
            font-weight: 600;
            font-size: 0.8rem;
          }
          .dh-enhanced-table thead th {
            background: #374151 !important;
            color: white !important;
            font-weight: 700 !important;
            font-size: 0.7rem !important;
            padding: 0.5rem 0.4rem !important;
          }
          .dh-enhanced-table tbody td {
            padding: 0.4rem !important;
            border: none;
            border-bottom: 1px solid #f3f4f6;
            font-size: 0.75rem;
            vertical-align: middle;
          }
          .grilla-semanal {
            font-size: 0.75rem;
          }
          .grilla-semanal td {
            padding: 0.25rem !important;
            vertical-align: middle;
          }
          .grilla-semanal select, .grilla-semanal input {
            font-size: 0.7rem;
            padding: 0.15rem 0.25rem;
          }
          .grilla-semanal thead th {
            font-size: 0.7rem !important;
            padding: 0.4rem 0.3rem !important;
          }
        `}
      </style>

      <div className="dh-maintenance-bg">
        <ToastContainer />

        <Container fluid className="py-4">
          <Row>
            <Col lg={12}>
              <Card className="dh-card">
                <Card.Header className="dh-card-header">
                  <div className="d-flex justify-content-between align-items-center">
                    <h5 className="mb-0">Mantenimiento Menus Ciclicos</h5>
                    <Button
                      className="btn-dh-secondary d-flex align-items-center"
                      onClick={() => navigate("/home")}
                      style={{ background: 'linear-gradient(135deg, #6b7280 0%, #4b5563 100%)', border: 'none', color: 'white', fontSize: '0.8rem', padding: '6px 12px' }}
                    >
                      <FaArrowLeft className="me-2" />
                      Volver
                    </Button>
                  </div>
                </Card.Header>
                <Card.Body style={{ padding: '1rem' }}>
                  <Tabs
                    activeKey={activeMainTab}
                    onSelect={(k) => setActiveMainTab(k)}
                    className="mb-4"
                  >
                    {/* TAB 1: Mantenimiento Individual */}
                    <Tab eventKey="individual" title={<span><FaClipboardList className="me-2" />Mantenimiento Individual</span>}>
                      <div className="d-flex justify-content-end gap-2 mb-4">
                        <Button onClick={handleOpenCreateModal} className="btn-dh-primary d-flex align-items-center">
                          <FaPlus className="me-2" />Nuevo
                        </Button>
                        <Button
                          className="btn-dh-warning d-flex align-items-center"
                          onClick={() => {
                            if (state.menuSeleccionado) {
                              handleOpenEditModal(state.menuSeleccionado);
                            } else {
                              toast.error("Por favor seleccione un menú para editar");
                            }
                          }}
                          style={{ background: 'linear-gradient(135deg, #fbbf24 0%, #f59e0b 100%)', border: 'none', color: 'white' }}
                        >
                          <FaEdit className="me-2" />Editar
                        </Button>
                        <Button
                          className="btn-dh-danger d-flex align-items-center"
                          onClick={() => handleDeleteMenu(state.menuSeleccionado)}
                          disabled={!state.menuSeleccionado}
                          style={{ background: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)', border: 'none', color: 'white' }}
                        >
                          <FaTrash className="me-2" />Eliminar
                        </Button>
                        <Button
                          className="btn-dh-info d-flex align-items-center"
                          onClick={() => {
                            if (state.menuSeleccionado) {
                              handleOpenGrilla(state.menuSeleccionado, 1);
                            } else {
                              toast.error("Por favor seleccione un menú para configurar la grilla");
                            }
                          }}
                          disabled={!state.menuSeleccionado}
                          style={{ background: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)', border: 'none', color: 'white' }}
                        >
                          <FaCalendarAlt className="me-2" />Configurar Semana
                        </Button>
                      </div>

                      <div className="mb-4">
                        <div className="position-relative">
                          <Form.Control
                            type="search"
                            placeholder="Buscar por nombre o descripción..."
                            value={state.filtro}
                            onChange={(e) => setState({ ...state, filtro: e.target.value })}
                            style={{ paddingLeft: '3rem', fontSize: '0.8rem', padding: '0.4rem 0.6rem' }}
                          />
                          <FaSearch className="position-absolute" style={{ left: '1rem', top: '50%', transform: 'translateY(-50%)', color: '#6b7280' }} />
                        </div>
                      </div>

                      <div className="table-responsive" style={{ maxHeight: '600px', overflowY: 'auto' }}>
                        <Table className="dh-enhanced-table">
                          <thead>
                            <tr>
                              <th style={{ width: "50px" }}></th>
                              <th>Código</th>
                              <th>Nombre</th>
                              <th>Descripción</th>
                              <th>Detalles</th>
                            </tr>
                          </thead>
                          <tbody>
                            {loading ? (
                              <tr>
                                <td colSpan="5" className="text-center py-5">
                                  <div className="spinner-border text-primary mb-3" role="status"></div>
                                  <div className="text-muted">Cargando menús cíclicos...</div>
                                </td>
                              </tr>
                            ) : menusFiltrados.length === 0 ? (
                              <tr>
                                <td colSpan="5" className="text-center py-5">
                                  <Alert variant="info" className="mb-0">
                                    <FaCalendarAlt className="me-2" />
                                    No se encontraron menús cíclicos
                                  </Alert>
                                </td>
                              </tr>
                            ) : (
                              menusFiltrados.map((menu) => (
                                <tr
                                  key={menu.id}
                                  className={state.menuSeleccionado?.id === menu.id ? 'selected' : ''}
                                  style={{ cursor: 'pointer' }}
                                  onClick={() => setState({ ...state, menuSeleccionado: menu })}
                                >
                                  <td>
                                    <Form.Check
                                      type="checkbox"
                                      checked={state.menuSeleccionado?.id === menu.id}
                                      onChange={() => {}}
                                    />
                                  </td>
                                  <td style={{ fontSize: '0.75rem', fontFamily: 'monospace' }}>{menu.codigo_interno || <span className="text-muted">Sin código</span>}</td>
                                  <td style={{ fontWeight: '600', fontSize: '0.75rem' }}>{menu.nombre}</td>
                                  <td style={{ fontSize: '0.75rem' }}>{menu.descripcion || <span className="text-muted">Sin descripción</span>}</td>
                                  <td style={{ fontSize: '0.75rem' }}>
                                    <Badge bg="info" style={{ fontSize: '0.7rem', padding: '0.2rem 0.5rem' }}>{menu.total_detalles || 0} detalles</Badge>
                                  </td>
                                </tr>
                              ))
                            )}
                          </tbody>
                        </Table>
                      </div>
                    </Tab>

                    {/* TAB 2: Carga Masiva */}
                    <Tab eventKey="masiva" title={<span><FaCalendarAlt className="me-2" />Carga Masiva</span>}>
                      {uploadStep === "select" && (
                        <>
                          <div className="d-flex justify-content-between align-items-center mb-3">
                            <Alert variant="info" className="mb-0 flex-grow-1 me-3" style={{ fontSize: '0.8rem', padding: '0.75rem' }}>
                              <h6 className="fw-bold mb-2" style={{ fontSize: '0.85rem' }}>
                                <FaCheckCircle className="me-2" />
                                Instrucciones para Carga Masiva
                              </h6>
                              <ol className="mb-0" style={{ fontSize: '0.75rem', paddingLeft: '1.25rem' }}>
                                <li className="mb-1">Descargue la plantilla Excel usando el botón</li>
                                <li className="mb-1">Complete los datos en el archivo Excel (columnas: <strong>nombre</strong>, <strong>tipo_fila</strong> "C" o "D", y campos según tipo)</li>
                                <li className="mb-1">Guarde el archivo en su computadora</li>
                                <li className="mb-1">Seleccione el archivo completado</li>
                                <li>Valide los datos y confirme la carga</li>
                              </ol>
                            </Alert>
                            <div className="d-flex gap-2">
                              <Button
                                className="btn-dh-primary"
                                onClick={() => setShowIndicacionesModal(true)}
                                style={{ minWidth: '150px' }}
                              >
                                <FaInfoCircle className="me-2" />
                                Indicaciones
                              </Button>
                              <Button
                                className="btn-dh-primary"
                                onClick={handleDownloadTemplate}
                                style={{ minWidth: '200px' }}
                              >
                                <FaDownload className="me-2" />
                                Descargar Template
                              </Button>
                            </div>
                          </div>

                          <Card style={{ border: '2px solid #3b82f6', borderRadius: '12px' }}>
                            <Card.Body className="text-center py-2">
                              <FaUpload size={28} className="text-primary mb-2" />
                              <h6 className="fw-bold mb-2" style={{ fontSize: '0.85rem' }}>Seleccionar Archivo Excel</h6>
                              <p className="text-muted mb-2" style={{ fontSize: '0.75rem' }}>Suba el archivo Excel completado para validar</p>
                              <div className="d-flex justify-content-center">
                                <Form.Control
                                  type="file"
                                  accept=".xlsx,.xls"
                                  onChange={handleFileSelect}
                                  style={{ maxWidth: '500px', fontSize: '0.8rem', padding: '0.4rem 0.6rem' }}
                                />
                              </div>
                              {selectedFile && (
                                <Alert variant="success" className="mt-2 mb-0 mx-auto" style={{ maxWidth: '500px', fontSize: '0.75rem', padding: '0.5rem' }}>
                                  <FaCheckCircle className="me-2" />
                                  <strong>{selectedFile.name}</strong>
                                </Alert>
                              )}
                            </Card.Body>
                          </Card>

                          {selectedFile && (
                            <div className="text-center mt-3">
                              <Button
                                className="btn-dh-info"
                                onClick={handleValidateFile}
                                disabled={uploadLoading}
                                style={{ background: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)', border: 'none', color: 'white' }}
                              >
                                <FaCheckCircle className="me-2" />
                                Validar Archivo
                              </Button>
                            </div>
                          )}
                        </>
                      )}

                      {uploadStep === "validating" && (
                        <div className="text-center py-3">
                          <div className="spinner-border text-primary mb-2" role="status" style={{ width: '1.5rem', height: '1.5rem' }}></div>
                          <h6 className="mb-2" style={{ fontSize: '0.85rem' }}>Validando archivo Excel...</h6>
                        </div>
                      )}

                      {uploadStep === "validated" && validationResult && (
                        <>
                          <Alert variant={validationResult.filas_validas > 0 ? "success" : "warning"} style={{ fontSize: '0.8rem', padding: '0.75rem' }}>
                            <h6 className="fw-bold mb-2" style={{ fontSize: '0.85rem' }}>
                              <FaCheckCircle className="me-2" />
                              Resultado de Validación
                            </h6>
                            <Row className="text-center">
                              <Col md={4}>
                                <div className="p-2">
                                  <h4 className="mb-0" style={{ fontSize: '1.2rem' }}>{validationResult.total_filas}</h4>
                                  <small className="text-muted" style={{ fontSize: '0.7rem' }}>Total Filas</small>
                                </div>
                              </Col>
                              <Col md={4}>
                                <div className="p-2">
                                  <h4 className="mb-0 text-success" style={{ fontSize: '1.2rem' }}>{validationResult.filas_validas}</h4>
                                  <small className="text-muted" style={{ fontSize: '0.7rem' }}>Filas Válidas</small>
                                </div>
                              </Col>
                              <Col md={4}>
                                <div className="p-2">
                                  <h4 className="mb-0 text-danger" style={{ fontSize: '1.2rem' }}>{validationResult.filas_invalidas}</h4>
                                  <small className="text-muted" style={{ fontSize: '0.7rem' }}>Filas Inválidas</small>
                                </div>
                              </Col>
                            </Row>
                          </Alert>

                          {validationResult.errores.length > 0 && (
                            <Alert variant="danger" style={{ fontSize: '0.8rem', padding: '0.75rem' }}>
                              <h6 className="fw-bold mb-2" style={{ fontSize: '0.85rem' }}>
                                <FaExclamationTriangle className="me-2" />
                                Errores encontrados ({validationResult.errores.length})
                              </h6>
                              <div style={{ maxHeight: '250px', overflowY: 'auto' }} className="mt-2">
                                <Table size="sm" striped bordered className="mb-0" style={{ fontSize: '0.75rem' }}>
                                  <thead>
                                    <tr>
                                      <th style={{ width: '80px' }}>Fila</th>
                                      <th style={{ width: '120px' }}>Campo</th>
                                      <th>Error</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {validationResult.errores.map((error, idx) => (
                                      <tr key={idx}>
                                        <td className="text-center"><Badge bg="danger">{error.fila}</Badge></td>
                                        <td><code>{error.campo}</code></td>
                                        <td>{error.error}</td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </Table>
                              </div>
                            </Alert>
                          )}

                          <div className="d-flex justify-content-center gap-3 mt-3">
                            <Button className="btn-dh-secondary" onClick={handleResetUpload} style={{ background: 'linear-gradient(135deg, #6b7280 0%, #4b5563 100%)', border: 'none', color: 'white' }}>
                              <FaTimes className="me-2" />
                              Seleccionar otro archivo
                            </Button>
                            {validationResult.filas_validas > 0 && (
                              <Button
                                className="btn-dh-primary"
                                onClick={handleConfirmUpload}
                                disabled={uploadLoading}
                              >
                                <FaUpload className="me-2" />
                                Confirmar Carga ({validationResult.filas_validas} filas)
                              </Button>
                            )}
                          </div>
                        </>
                      )}

                      {uploadStep === "uploading" && (
                        <div className="text-center py-3">
                          <div className="spinner-border text-success mb-2" role="status" style={{ width: '1.5rem', height: '1.5rem' }}></div>
                          <h6 className="mb-2" style={{ fontSize: '0.85rem' }}>Cargando datos al sistema...</h6>
                          <ProgressBar animated now={100} className="mt-2" style={{ height: '14px' }} />
                        </div>
                      )}

                      {uploadStep === "success" && (
                        <Alert variant="success" className="text-center py-2" style={{ fontSize: '0.8rem', padding: '0.75rem' }}>
                          <FaCheckCircle size={30} className="text-success mb-2" />
                          <h5 className="fw-bold mb-2" style={{ fontSize: '0.9rem' }}>¡Carga completada exitosamente!</h5>
                          <Button className="btn-dh-primary" onClick={handleResetUpload}>
                            <FaPlus className="me-2" />
                            Cargar otro archivo
                          </Button>
                        </Alert>
                      )}
                    </Tab>
                  </Tabs>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      {/* Modal CRUD Cabecera */}
      {showModalCabecera && (
        <Modal show={showModalCabecera} onHide={handleCloseModalCabecera} size="lg">
          <Modal.Header closeButton style={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', color: 'white', padding: '0.75rem 1rem' }}>
            <Modal.Title style={{ fontSize: '0.9rem' }}>
              <FaCalendarAlt className="me-2" />
              {modalMode === 'create' ? 'Nuevo Menú Cíclico' : 'Editar Menú Cíclico'}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ padding: '0.75rem' }}>
            <Form>
              <Row className="mb-1">
                <Col md={6}>
                  <Form.Group className="mb-0">
                    <Form.Label className="fw-bold" style={{ fontSize: '0.8rem', marginBottom: '0.2rem' }}>
                      Código Interno *
                    </Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Ej: MENU_SEM1"
                      value={formDataCabecera.codigo_interno || ''}
                      onChange={(e) => setFormDataCabecera({...formDataCabecera, codigo_interno: e.target.value})}
                      required
                      maxLength={50}
                      style={{ fontSize: '0.8rem', padding: '0.4rem 0.6rem' }}
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-0">
                    <Form.Label className="fw-bold" style={{ fontSize: '0.8rem', marginBottom: '0.2rem' }}>
                      Nombre *
                    </Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Ej: Menú Semanal 1"
                      value={formDataCabecera.nombre || ''}
                      onChange={(e) => setFormDataCabecera({...formDataCabecera, nombre: e.target.value})}
                      required
                      maxLength={255}
                      style={{ fontSize: '0.8rem', padding: '0.4rem 0.6rem' }}
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Row className="mb-1">
                <Col md={12}>
                  <Form.Group className="mb-0">
                    <Form.Label className="fw-bold" style={{ fontSize: '0.8rem', marginBottom: '0.2rem' }}>
                      Descripción
                    </Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={2}
                      placeholder="Descripción del menú cíclico"
                      value={formDataCabecera.descripcion || ''}
                      onChange={(e) => setFormDataCabecera({...formDataCabecera, descripcion: e.target.value})}
                      maxLength={1000}
                      style={{ fontSize: '0.8rem', padding: '0.4rem 0.6rem' }}
                    />
                  </Form.Group>
                </Col>
              </Row>
            </Form>
          </Modal.Body>
          <Modal.Footer style={{ padding: '0.5rem 0.75rem' }}>
            <Button variant="secondary" onClick={handleCloseModalCabecera} style={{ fontSize: '0.8rem', padding: '0.3rem 0.6rem' }}>
              <FaTimes className="me-1" />
              Cancelar
            </Button>
            <Button
              variant="primary"
              onClick={handleSaveCabecera}
              disabled={!formDataCabecera.nombre || formDataCabecera.nombre.trim().length < 1 || loading}
              style={{ fontSize: '0.8rem', padding: '0.3rem 0.6rem' }}
            >
              <FaCheck className="me-1" />
              {modalMode === 'create' ? 'Crear' : 'Actualizar'}
            </Button>
          </Modal.Footer>
        </Modal>
      )}

      {/* Modal Grilla Semanal */}
      {showModalGrilla && menuActual && (
        <Modal show={showModalGrilla} onHide={handleCloseGrilla} size="xl" fullscreen="lg-down">
          <Modal.Header closeButton style={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', color: 'white', padding: '0.75rem 1rem' }}>
            <Modal.Title style={{ fontSize: '0.9rem' }}>
              <FaCalendarAlt className="me-2" />
              Configurar Semana {semanaOrdinal} - {menuActual.nombre}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ padding: '0.5rem', maxHeight: '70vh', overflowY: 'auto' }}>
            <div className="mb-2">
              <Form.Group>
                <Form.Label className="fw-bold" style={{ fontSize: '0.75rem', marginBottom: '0.2rem' }}>Semana Ordinal:</Form.Label>
                <Form.Control
                  type="number"
                  min="1"
                  value={semanaOrdinal}
                  onChange={(e) => {
                    const nuevaSemana = parseInt(e.target.value) || 1;
                    setSemanaOrdinal(nuevaSemana);
                    handleOpenGrilla(menuActual, nuevaSemana);
                  }}
                  style={{ fontSize: '0.75rem', maxWidth: '150px', padding: '0.3rem 0.5rem' }}
                />
              </Form.Group>
            </div>

            {/* Leyenda de colores */}
            <div className="mb-3 p-2" style={{ backgroundColor: '#f8f9fa', borderRadius: '8px', border: '1px solid #dee2e6' }}>
              <div className="d-flex align-items-center justify-content-center gap-4 flex-wrap">
                <small className="fw-bold text-muted" style={{ fontSize: '0.7rem' }}>Estado de Configuración:</small>
                <div className="d-flex align-items-center gap-1">
                  <div style={{ 
                    width: '12px', 
                    height: '12px', 
                    backgroundColor: '#d4edda', 
                    border: '1px solid #c3e6cb',
                    borderRadius: '3px' 
                  }}></div>
                  <small style={{ fontSize: '0.7rem' }}>Completo</small>
                </div>
                <div className="d-flex align-items-center gap-1">
                  <div style={{ 
                    width: '12px', 
                    height: '12px', 
                    backgroundColor: '#fff3cd', 
                    border: '1px solid #ffeaa7',
                    borderRadius: '3px' 
                  }}></div>
                  <small style={{ fontSize: '0.7rem' }}>Parcial</small>
                </div>
                <div className="d-flex align-items-center gap-1">
                  <div style={{ 
                    width: '12px', 
                    height: '12px', 
                    backgroundColor: '#f8d7da', 
                    border: '1px solid #f5c6cb',
                    borderRadius: '3px' 
                  }}></div>
                  <small style={{ fontSize: '0.7rem' }}>Vacío</small>
                </div>
              </div>
            </div>

            <div className="table-responsive">
              <Table bordered className="grilla-semanal">
                <thead>
                  <tr>
                    <th style={{ background: '#374151', color: 'white', position: 'sticky', left: 0, zIndex: 5, fontSize: '0.7rem', padding: '0.4rem 0.3rem' }}>
                      Tipo Servicio
                    </th>
                    {DIAS_SEMANA.map(dia => (
                      <th key={dia.id} style={{ background: '#374151', color: 'white', minWidth: '150px', fontSize: '0.7rem', padding: '0.4rem 0.3rem' }}>
                        {dia.nombre}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {tiposServicio.map(tipoServicio => (
                    <tr key={tipoServicio.id}>
                      <td style={{ background: '#f3f4f6', fontWeight: '600', position: 'sticky', left: 0, zIndex: 4, fontSize: '0.7rem' }}>
                        {tipoServicio.descripcion}
                      </td>
                      {DIAS_SEMANA.map(dia => (
                        <td key={dia.id} style={{ 
                          background: getCeldaBackgroundColor(tipoServicio.id, dia.id),
                          transition: 'background-color 0.3s ease'
                        }}>
                          <div className="mb-1">
                            <Form.Select
                              size="sm"
                              value={getCeldaValue(tipoServicio.id, dia.id, 'tipo_componente_menu_codigo')}
                              onChange={(e) => handleUpdateCelda(tipoServicio.id, dia.id, 'tipo_componente_menu_codigo', e.target.value)}
                              style={{ fontSize: '0.7rem' }}
                            >
                              <option value="">Seleccionar Tipo Componente</option>
                              {tiposComponente.map(tipo => (
                                <option key={tipo.id} value={tipo.codigo_interno}>
                                  {tipo.nombre}
                                </option>
                              ))}
                            </Form.Select>
                          </div>
                          <div className="mb-1">
                            <Form.Select
                              size="sm"
                              value={getCeldaValue(tipoServicio.id, dia.id, 'receta_codigo')}
                              onChange={(e) => handleUpdateCelda(tipoServicio.id, dia.id, 'receta_codigo', e.target.value)}
                              style={{ fontSize: '0.7rem' }}
                            >
                              <option value="">Seleccionar Receta</option>
                              {recetas.map(receta => (
                                <option key={receta.id} value={receta.codigo_interno}>
                                  {receta.nombre}
                                </option>
                              ))}
                            </Form.Select>
                          </div>
                          <div>
                            <Form.Control
                              type="number"
                              step="0.01"
                              min="0.01"
                              max="1"
                              size="sm"
                              placeholder="Factor"
                              value={getCeldaValue(tipoServicio.id, dia.id, 'factor')}
                              onChange={(e) => handleUpdateCelda(tipoServicio.id, dia.id, 'factor', e.target.value)}
                              style={{ fontSize: '0.7rem' }}
                            />
                          </div>
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          </Modal.Body>
          <Modal.Footer style={{ padding: '0.5rem 0.75rem' }}>
            <Button variant="secondary" onClick={handleCloseGrilla} style={{ fontSize: '0.8rem', padding: '0.3rem 0.6rem' }}>
              <FaTimes className="me-1" />
              Cancelar
            </Button>
            <Button
              variant="primary"
              onClick={handleSaveGrilla}
              disabled={loading}
              style={{ fontSize: '0.8rem', padding: '0.3rem 0.6rem' }}
            >
              <FaSave className="me-1" />
              Guardar
            </Button>
          </Modal.Footer>
        </Modal>
      )}

      {/* Modal Indicaciones */}
      <Modal show={showIndicacionesModal} onHide={() => setShowIndicacionesModal(false)} size="lg">
        <Modal.Header closeButton style={{ padding: '0.75rem 1rem' }}>
          <Modal.Title style={{ fontSize: '0.9rem' }}>
            <FaInfoCircle className="me-2" />
            Indicaciones para Carga Masiva
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ padding: '0.75rem 1rem' }}>
          <Alert variant="info" style={{ fontSize: '0.8rem', padding: '0.75rem' }}>
            <h6 className="fw-bold" style={{ fontSize: '0.85rem' }}>Formato del Archivo Excel:</h6>
            <p style={{ fontSize: '0.8rem', marginBottom: '0.5rem' }}>El archivo debe contener las siguientes columnas:</p>
            <ul style={{ fontSize: '0.75rem', paddingLeft: '1.5rem' }}>
              <li className="mb-1"><strong>nombre</strong>: Nombre del menú cíclico (obligatorio)</li>
              <li className="mb-1"><strong>tipo_fila</strong>: "C" para Cabecera, "D" para Detalle (obligatorio, debe ser la segunda columna)</li>
              <li className="mb-1"><strong>descripcion</strong>: Descripción del menú (opcional, solo para tipo "C")</li>
              <li className="mb-1"><strong>semana_ordinal</strong>: Número de semana (obligatorio para tipo "D")</li>
              <li className="mb-1"><strong>dia_semana</strong>: Día de la semana 1-7 (1=Lunes, 7=Domingo) (obligatorio para tipo "D")</li>
              <li className="mb-1"><strong>tipo_servicio_alimentacion_id</strong>: ID del tipo de servicio (obligatorio para tipo "D")</li>
              <li className="mb-1"><strong>tipo_componente_menu_id</strong>: ID del tipo de componente (obligatorio para tipo "D")</li>
              <li className="mb-1"><strong>receta_cabecera_id</strong>: ID de la receta (obligatorio para tipo "D")</li>
              <li className="mb-1"><strong>factor</strong>: Factor de ajuste 0-1 (obligatorio para tipo "D")</li>
            </ul>
            <p className="mb-0" style={{ fontSize: '0.75rem' }}><strong>Nota:</strong> Cada menú debe tener exactamente una fila tipo "C" (cabecera) seguida de sus filas tipo "D" (detalles).</p>
          </Alert>
        </Modal.Body>
        <Modal.Footer style={{ padding: '0.5rem 0.75rem' }}>
          <Button variant="secondary" onClick={() => setShowIndicacionesModal(false)} style={{ fontSize: '0.8rem', padding: '0.3rem 0.6rem' }}>
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal de confirmación de eliminación */}
      <ModalConfirmacion
        show={showConfirmModal}
        onHide={() => {
          setShowConfirmModal(false);
          setMenuToDelete(null);
        }}
        onConfirm={confirmDeleteMenu}
        title="Confirmar Eliminación"
        message={
          menuToDelete
            ? `¿Está seguro de eliminar el menú cíclico "${menuToDelete.nombre}"? Se eliminarán también todos sus detalles.`
            : ""
        }
        confirmText="Eliminar"
        cancelText="Cancelar"
        loading={loading}
        variant="danger"
      />
    </>
  );
};

export default MantenimientoMenusCiclicos;

